module.exports = __webpack_public_path__ + "static/IBM_Carbon_cover-36cd120c5072e0ff09e8fc49210ec986.png";